import { useCallback, useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { addUserRequest, clearUserValues } from "../../../redux/user/action";
import { AddNewUserType } from "../../organisms/CreateUserForm/CreateUserForm";
import { CreateUser } from "../../templates/CreateUser"
import { Alert } from "../../atoms/Alert";
import { clearSpecificRequest } from "../../../redux/request/action";
import { ADD_USER_REQUEST } from "../../../redux/user/actionType";

const CreateUserPage = () => {
  const history = useHistory();

  const dispatch = useDispatch();
  
  const user = useSelector((state: RootStateOrAny) => state.auth.user);

  const dispatchAddUser = useCallback(
    (user: AddNewUserType) => { 
      const { fullName, ...newUser } = user;
      dispatch(addUserRequest({ ...newUser, name: fullName }));
    },
    [dispatch],
  );

  const userRequest = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[ADD_USER_REQUEST],
  );

  const error = useSelector((state: RootStateOrAny) => state.user.error);

  const isAddedSuccessfully = useSelector((state: RootStateOrAny) => state.user.isAddedSuccessfully);

  useEffect(() => {
    dispatch(clearUserValues());
    dispatch(clearSpecificRequest(ADD_USER_REQUEST))
  }, [dispatch])

  useEffect(() => {
    if (isAddedSuccessfully) {
      history.replace('/admin/users')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAddedSuccessfully]);
  
  const onBack = () => {
    return history.goBack();
  };
  
  return (
    <>
      <CreateUser 
        isLoading={userRequest?.isLoading}
        onBack={onBack} 
        onCreateUser={dispatchAddUser}
        isSuperAdmin={user.isSuperAdmin}
      />
      {error && <Alert type="error" message={error} showIcon />}
    </>
  )
}

export default CreateUserPage;
